<template>
  <div id="contents-detail">
    <div>
      <content-item-editor v-for="editorId in editorIds" :id="editorId" :key="editorId" :remove-plugins="['Font']">
      </content-item-editor>
    </div>

    <div class="col-md-12 pr-0">
      <div class="form-inline form-group pull-right">
        <input
          id="add-part"
          type="button"
          class="btn btn-primary add-part"
          value="목차 추가"
          @click="addContentItemEditor()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
  props: ['contentId', 'initialContentItems'],
  data() {
    return {
      editorIds: [],
      numberOfContentItemsIncludingDeletedContentItems: 0,
    };
  },
  created() {
    this.initContentEditor();
    this.$on('deleteContentItem', this.deleteContentItem);
    this.$on('upContentItem', this.upContentItem);
    this.$on('downContentItem', this.downContentItem);
  },
  methods: {
    initContentEditor() {
      for (let initialContentItem of this.initialContentItems) {
        let contentItem = this.createContentItemFromInitialContentItem(initialContentItem);
        this.$store.commit('createContentItemEditor', contentItem);
        this.editorIds.push(contentItem.editorId);
      }
    },

    addContentItemEditor() {
      let contentItem = this.createContentItem(null, '', '');
      this.$store.commit('createContentItemEditor', contentItem);
      this.editorIds.push(contentItem.editorId);
      EventBus.$emit('setIsSavedContent', false);
    },

    createContentItemFromInitialContentItem(initialContentItem) {
      return this.createContentItem(initialContentItem.id, initialContentItem.title, initialContentItem.description);
    },

    createContentItem(id, title, description) {
      let contentItem = {};
      contentItem.editorId = this.generateEditorId();
      contentItem.id = id;
      contentItem.title = title;
      contentItem.description = description;
      contentItem.relativeOrder = this.numberOfContentItemsIncludingDeletedContentItems++;

      return contentItem;
    },

    generateEditorId() {
      return Math.random().toString(36).substring(7);
    },

    deleteContentItem(editorIdToDelete) {
      let indexToDelete = this.editorIds.indexOf(editorIdToDelete);
      if (indexToDelete >= 0) {
        this.editorIds.splice(indexToDelete, 1);
      }
      EventBus.$emit('setIsSavedContent', false);
      this.$store.commit('deleteContentItemEditor', editorIdToDelete);
    },

    upContentItem(editorIdToUp) {
      let indexToUp = this.editorIds.indexOf(editorIdToUp);
      if (indexToUp > 0) {
        EventBus.$emit('setIsSavedContent', false);
        let indexToDown = indexToUp - 1;
        let editorIdToDown = this.editorIds[indexToDown];
        this.swapContentItems(indexToDown, indexToUp, editorIdToUp, editorIdToDown);
      }
    },

    downContentItem(editorIdToDown) {
      let indexToDown = this.editorIds.indexOf(editorIdToDown);
      if (indexToDown >= 0 && indexToDown < this.editorIds.length - 1) {
        EventBus.$emit('setIsSavedContent', false);
        let indexToUp = indexToDown + 1;
        let editorIdToUp = this.editorIds[indexToUp];
        this.swapContentItems(indexToDown, indexToUp, editorIdToUp, editorIdToDown);
      }
    },

    swapContentItems(indexToDown, indexToUp, editorIdToUp, editorIdToDown) {
      this.commitSwapContentItemEditorRelativeOrders(editorIdToUp, editorIdToDown);
      this.swapContentItemEditorIds(indexToDown, editorIdToUp, editorIdToDown);
    },

    commitSwapContentItemEditorRelativeOrders(editorIdToUp, editorIdToDown) {
      this.$store.commit({
        type: 'swapContentItemEditorRelativeOrders',
        editorIdA: editorIdToUp,
        editorIdB: editorIdToDown,
      });
    },

    swapContentItemEditorIds(indexToDown, editorIdToUp, editorIdToDown) {
      this.editorIds.splice(indexToDown, 2, editorIdToUp, editorIdToDown);
    },
  },
};
</script>
